import dayjs from "dayjs";

// Mock orders in the shape the backend returns (see GET /orders in
// dm-commerce-b2b-web/src/features/order/order.ts and its OrderList page).

const PRODUCTS = [
  "Wireless Earbuds",
  "Cotton Panjabi",
  "Smart Watch",
  "Leather Wallet",
  "Handloom Saree",
  "Bluetooth Speaker",
  "Running Shoes",
  "Table Lamp",
];
const NAMES = ["Karim Ahmed", "Nusrat Jahan", "Rafiq Islam", "Tania Akter", "Mahmud Hasan", "Farhana Yeasmin"];
// tm's purchase pipeline (RemoteSale tabs): every order list / stage page has rows in mock mode
export const PIPELINE = [
  "Pending Payment",
  "Order Initiated",
  "Purchasing",
  "Purchase Completed",
  "Shipped From Supplier",
  "Received In China Warehouse",
  "On The Way To China Airport",
  "Received In China Airport",
  "On The Way To BD Airport",
  "Received In BD Airport",
  "On The Way To BD Warehouse",
  "Received In BD Warehouse",
  "Processing For Delivery",
  "On The Way To Delivery",
  "Completed",
  "Processing For Refund",
  "Refunded",
  "Cancelled",
];
const STATUSES = PIPELINE;

const makeOrder = (i) => {
  const status = STATUSES[i % STATUSES.length];
  const COLORS = ["Black", "Burgundy", "Navy", "Beige"];
  const rawItems = [
    { itemName: `${PRODUCTS[i % PRODUCTS.length]} - Standard`, color: COLORS[i % 4], quantity: (i % 3) + 1, price: 850 + (i % 5) * 150 },
    ...(i % 4 === 0
      ? [{ itemName: `${PRODUCTS[(i + 3) % PRODUCTS.length]} - Large`, color: COLORS[(i + 1) % 4], quantity: 1, price: 1250 }]
      : []),
  ];
  const items = rawItems.map((item, index) => ({
    id: (1000 + i) * 10 + index,
    variant: `Color: ${item.color}`,
    itemImage: "",
    productDiscount: 0,
    subTotal: item.quantity * item.price,
    ...item,
  }));
  const subTotal = items.reduce((sum, item) => sum + item.quantity * item.price, 0);
  const shippingCost = 120;
  const otherCharge = i % 3 === 0 ? 50 : 0;
  const orderDiscount = i % 5 === 0 ? 100 : 0;
  const totalAmount = subTotal + shippingCost + otherCharge - orderDiscount;

  const paidAmount =
    status === "Pending Payment" || status === "Cancelled"
      ? 0
      : status === "Order Initiated" || i % 7 === 2
      ? Math.round(totalAmount / 2)
      : totalAmount;
  const paymentStatus =
    paidAmount === 0 ? "UNPAID" : paidAmount < totalAmount ? "PARTIALLY_PAID" : "PAID";

  return {
    id: 1000 + i,
    code: `ORD-${10001 + i}`,
    orderDate: dayjs().subtract(i * 2, "hour").toISOString(),
    orderType: "Remote Sale",
    productTitle: items[0].itemName,
    productImage: "",
    currency: "BDT",
    status,
    paymentStatus,
    partialAmount: Math.round(totalAmount * 0.3),
    paidAmount,
    orderDiscount,
    shippingCost,
    otherCharge,
    state: {
      totalItem: items.reduce((sum, item) => sum + item.quantity, 0),
      subTotal,
      totalAmount,
    },
    orderItems: items,
    customerName: NAMES[i % NAMES.length],
    customerPhone: `+880 17${String(10000000 + i * 4321).slice(0, 8)}`,
    customerEmergencyPhone: `+880 18${String(20000000 + i * 1234).slice(0, 8)}`,
    deliveryAddress: `House ${10 + i}, Road ${(i % 9) + 1}, Dhaka`,
    deliveryMethod: i % 2 ? "Courier" : "Home Delivery",
    customerNotes: i % 4 === 0 ? "Please call before delivery" : "",

    // order details page (tm ApiOrderItem / ApiOrderSummary / ApiAdditionalDetails)
    b2bUserId: 5,
    // a few orders were placed with a coupon at checkout
    couponCode: orderDiscount > 0 ? "SAVE100" : null,
    couponDiscount: orderDiscount > 0 ? orderDiscount : 0,
    description: i % 3 === 0 ? "Handle with care" : "",
    shippingAddress: `House ${10 + i}, Road ${(i % 9) + 1}, Dhaka`,
    createdDateTime: dayjs().subtract(i * 2, "hour").toISOString(),
    updatedDateTime: dayjs().subtract(i, "hour").toISOString(),
    productCode: `P${100200 + i}`,
    sourceLink: "https://detail.1688.com/offer/123456.html",
    approximatelyDeliveryFromDate: i % 2 ? dayjs().add(20, "day").toISOString() : null,
    b2bUser: { id: 5, identificationShortCode: "AG-1002", companyName: "Sky Travels" },
    city: "Dhaka",
    district: "Dhaka",
    address: `House ${10 + i}, Road ${(i % 9) + 1}, Dhaka`,
    initiateVendorAmount: 2400,
    initiateVendorCurrency: "CNY",
    initiateVendorEquivalentAmount: 41000,
    initiateVendorEquivalentCurrency: "BDT",
    vendorAmount: 0,
    vendorCurrency: "CNY",
    vendorEquivalentAmount: 0,
    vendorEquivalentCurrency: "BDT",
    // the vendor the goods were bought from (set once the purchase is initiated)
    vendorId: i % STATUSES.length >= 2 && status !== "Cancelled" ? 1 : null,
    vendor: i % STATUSES.length >= 2 && status !== "Cancelled" ? { id: 1, identificationShortCode: "V-101", vendorName: "Guangzhou Sourcing Co" } : null,
    purchaseInitiatorByUser: { identificationShortCode: "EMP-101", firstname: "Sakib", lastname: "Khan" },
    purchaseCompletedByUser: null,
    shipment: {
      id: 900 + i,
      method: i % 2 ? "Air" : null,
      route: i % 2 ? "Guangzhou" : null,
      userForeignAmount: 0,
      userForeignCurrency: "CNY",
      userForeignEquivalentAmount: 0,
      userForeignToLocalAmount: 0,
      userForeignToLocalEquivalentAmount: 0,
      userLocalAmount: 0,
      initialWeight: null,
      actualWeight: null,
      userWeight: null,
      trackings: [],
    },
    notes: [
      {
        id: (1000 + i) * 100 + 1,
        badge: "General",
        privacy: "Public",
        description: "Customer asked for a faster delivery slot.",
        createdByUser: { identificationShortCode: "EMP-101", firstname: "Karim", lastname: "Ahmed" },
        createdDateTime: dayjs().subtract(i + 1, "hour").toISOString(),
        customerNotification: {
          isRead: i % 2 === 0,
          readAt: i % 2 === 0 ? dayjs().subtract(i, "hour").toISOString() : null,
          sentAt: dayjs().subtract(i + 1, "hour").toISOString(),
        },
      },
    ].slice(0, i % 3),
    ledgerData:
      paidAmount > 0
        ? [
            {
              id: (1000 + i) * 100 + 2,
              referenceId: `PMT25121${String(i).padStart(4, "0")}`,
              transactionCategory: "PAYMENT",
              transactionType: "DEDUCT",
              debit: Math.round(paidAmount * 0.7),
              credit: 0,
              createdDateTime: dayjs().subtract(i + 2, "day").toISOString(),
              narration: "Partial First",
            },
            ...(paidAmount > 100
              ? [
                  {
                    id: (1000 + i) * 100 + 3,
                    referenceId: `PMT25121${String(i + 50).padStart(4, "0")}`,
                    transactionCategory: "PAYMENT",
                    transactionType: "DEDUCT",
                    debit: paidAmount - Math.round(paidAmount * 0.7),
                    credit: 0,
                    createdDateTime: dayjs().subtract(i, "day").toISOString(),
                    narration: "Partial Second",
                  },
                ]
              : []),
          ]
        : [],
  };
};

// Mutable so Cancel in the details page sticks for the session
export const mockOrders = Array.from({ length: 30 }, (_, i) => makeOrder(i));

// Find an order by id; unknown numeric ids (e.g. /dashboard/order/41) get a generated one
export const findMockOrder = (id) => {
  const found = mockOrders.find((o) => String(o.id) === String(id));
  if (found || !/^\d+$/.test(String(id))) return found;
  const created = { ...makeOrder(Number(id) % 30), id: Number(id), code: `CM${id}` };
  mockOrders.push(created);
  return created;
};

// Recompute totals after an item edit (price / quantity / discount)
export const recalcOrder = (order) => {
  order.orderItems.forEach((item) => {
    item.subTotal = item.quantity * item.price - (+item.productDiscount || 0);
  });
  order.state.subTotal = order.orderItems.reduce((sum, item) => sum + item.subTotal, 0);
  order.state.totalItem = order.orderItems.reduce((sum, item) => sum + (+item.quantity || 0), 0);
  order.state.totalAmount =
    order.state.subTotal - (+order.orderDiscount || 0) + (+order.shippingCost || 0) + (+order.otherCharge || 0);
  return order;
};

// "Not Pending Payment" is the commerce app's default tab filter
// `status` may be one status or a comma separated list (the API accepts both)
export const filterByStatus = (orders, status) => {
  if (!status || status === "ALL") return orders;
  if (status === "Not Pending Payment") return orders.filter((o) => o.status !== "Pending Payment");
  const wanted = String(status).split(",").map((s) => s.trim());
  return orders.filter((o) => wanted.includes(o.status));
};

// Same shape as GET /orders/dashboard-summary:
// { counts: { unpaid|paid|processed|completed: { total, changePercent, trend } }, monthly: [{ label, total }] }
export const buildSummary = (orders = mockOrders) => {
  const count = (predicate) => orders.filter(predicate).length;
  const metric = (total, changePercent) => ({
    total,
    changePercent: Math.abs(changePercent),
    trend: changePercent >= 0 ? "up" : "down",
  });

  return {
    counts: {
      unpaid: metric(count((o) => o.paymentStatus === "UNPAID" && o.status !== "Cancelled"), -10),
      paid: metric(count((o) => o.paymentStatus === "PAID"), 10),
      processed: metric(count((o) => PIPELINE.slice(2, 14).includes(o.status)), 10),
      completed: metric(count((o) => o.status === "Completed"), -10),
    },
    monthly: ["May", "Jun", "Jul", "Aug", "Sep", "Oct"].map((label, i) => ({
      label,
      total: [124000, 86500, 152000, 98000, 187000, 142500][i],
    })),
  };
};
